import debug from 'debug';
import closeIcon from 'Minetilbud/Shared/Icons/luk_solid.svg';

const log = debug('Overlay:Templates');

class Templates {
	/**
	 * @param {Object} options
	 * @param {string} options.cssClass
	 * @param {string} options.instanceId
	 * @param {string} options.template
	 */
	container({ cssClass, instanceId, template }) {
		return `
			<section class="o-overlay ${ cssClass !== undefined ? cssClass : ''}" data-overlay="container-${instanceId}">
				<div class="o-overlay__template" data-overlay="template">${template}</div>
			</section>
		`;
	}

	modal({ baseClass, view }) {
		return `
				<a href="#mt" class="o-overlay-modal__close" data-ref="${baseClass}__close">${closeIcon}</a>
				<div class="o-overlay-modal__content" data-js="${baseClass}__content">${view}</div>
		`;
	}
}

export default Templates;
